<template>
    <div id="devdash-login" class="apply-bootstrap">
        <div class="container">
            <div class="row" id="devdash-login-form">
                <div id="devdashLogo">
                    <img alt="DevDash Login Page" src="../../devDash/images/devDashLogo.png">
                </div>
                <div class="login-form-area">
                    <div class="devdash-login-centered">
                        <h1>Developer Dashboard</h1>
                    </div>
                    <login-form c-id="loginForm" :prop-form-params="formParams" prop-instance="dev" prop-user-type="user" prop-message-box=""></login-form>
                </div>
                <div v-if="showLinkToAnotherInstance">
                    <p>To access Devdash using {{isProd ? 'QA' : 'production'}} components, datasets, and layouts, click here: <a :href="isProd ? urlOrigin : urlOrigin + '/?isprod'">{{isProd ? 'QA' : 'Production'}} DevDash</a></p>
                </div>
                <div v-if="showLinkToSwitchBetweenInstanceAndLocal">
                    <p>Switch to: <a href="javascript:void(0)" @click="switchBetweenInstanceAndLocal">{{devDashInstanceDetails.isLocalhost ? (isProd ? 'Production' : 'QA') : 'Localhost'}} DevDash</a></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import "@common/syncfusionCss";
import { router } from "@common/router/router";
import { configStore } from "@common/configStore";

const devDashLoginComponent = {
    data() {
        return {
            urlOrigin: false,
            showLinkToAnotherInstance: false,
            showLinkToSwitchBetweenInstanceAndLocal: false,
            devDashInstanceDetails: {}
        };
    },
    computed: {
        isProd() {
            return this.devDashInstanceDetails?.isProd || false;
        },
        formParams() {
            return {
                hideInstanceList: false,
                showResetPwd: false,
                inlineLabel: false,
                copyrightContent: this.copyrightContent,
                clientSsoLabelAfterButton: false,
                clientSsoContactInformation: false,
                clientSsoButtonConfig: false
            };
        },
        copyrightContent() {
            return `
                <span>
                    Developer Dashboard (DevDash) is a product and service of Samaritan.<br>
                    Copyright &copy; 2000 - ` + (new Date().getFullYear()) + ` Samaritan Software, LLC. All rights reserved world wide.
                </span>
            `;
        },
    },
    components: {
        loginForm: defineAsyncComponent(() => import('@common/loginForm/loginForm.vue'))
    },
    methods: {
        processAction: async function (act) {
            switch (act) {
                case 'login':
                    router.replace({ path: '/' });
                    break;
            }
        },
        switchBetweenInstanceAndLocal: () => {
            actionStore.switchBetweenInstanceAndLocal();
        }
    },
    async mounted() {
        this.devDashInstanceDetails = await configStore.getCurrentInstanceDetails(true);
        this.showLinkToAnotherInstance = typeof FROM_LOCALHOST !== 'undefined' ? FROM_LOCALHOST : false;
        this.urlOrigin = window.location.origin;
        library.setSessionStorage('devDashEnv', this.devDashInstanceDetails.isProd ? 'prod' : 'dev');

        this.showLinkToSwitchBetweenInstanceAndLocal = this.devDashInstanceDetails.isLocalhost || this.devDashInstanceDetails.quicklink;
    }
};

export default devDashLoginComponent;
</script>

<style lang="css">
body {
    background-color:#FFFFFF;
    margin:0
}

#devdash-login .devdash-login-centered {
    text-align: center;
    margin: 20px 0px 10px 0px;
}

#devdash-login h1, #devdash-login .h1 {
    color: #005C8F;
    font-family: 'Arial';
    font-size: 16pt;
    font-weight: bold;
}

#devdashLogo {
    margin: 0 auto;
    display: inline-block;
}

#devdash-login button {
    text-transform: none !important;
}

#devdash-login {
    text-align: center;
}

#devdash-login .e-control-wrapper {
    border-bottom-width: 1px;
    border-bottom-color: #D4D4D4;
}

#devdash-login .e-input {
    border-bottom-width: 0px;
    padding: 3px 5px;
}

#devdash-login .custom-message-container {
    width: 100%;
}

#devdash-login-form {
    width: 490px;
    max-width: 90%;
    margin: 0 auto;
    text-align: center;
    display: block;
}

#devdash-login .login-form-area {
    margin: 10px auto;
}

</style>
